import { createGlobalStyle } from "styled-components"

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background-color: #f1f1f1;
    overflow-x: hidden;
  }

  html {
    font-size: 10px;
    font-family: 'Open Sans', sans-serif;
  }

  #___gatsby {
    max-width: 1366px;
    margin: 0 auto;
  }
`
